import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const ClubSanctionPaymentIntentApi = (data) =>
    API.post(`${URL.CLUB_SANCTION_PAYMENT_INTENT_CREATE}`, data)
export const ClubSanctionPaymentSuccessApi = (data) =>
    API.post(`${URL.CLUB_SANCTION_PAYMENT_SUCCESS}`, data)
